"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.HbCheckItems = void 0;
exports.HbCheckItems = [
    'chatBotCheck',
    'menuChecks',
    'blockChecks',
    'algorithmGroupChecks',
];
